import { render } from "./RadioButtonList.vue?vue&type=template&id=be751040&scoped=true&ts=true"
import script from "./RadioButtonList.vue?vue&type=script&lang=ts"
export * from "./RadioButtonList.vue?vue&type=script&lang=ts"

import "./RadioButtonList.vue?vue&type=style&index=0&id=be751040&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be751040"]])

export default __exports__